export default "__VITE_ASSET__DkGCRqzw__"